import type { EvWorkflowEvent } from "../../ev-workstation/types/index.ts";

const VISIBLE_MANUAL_EVENT_TYPES = new Set(["note_added", "reminder_added", "commitment_added"]);

export function isVisibleWorkflowTimelineEvent(event: EvWorkflowEvent): boolean {
  if (event.source !== "manual" && event.source !== "agent") return false;
  if (VISIBLE_MANUAL_EVENT_TYPES.has(event.eventType)) return true;
  if (event.eventType.endsWith("_changed")) return true;
  return Boolean(event.note?.trim());
}

export function formatWorkflowTimelineEventLabel(eventType: string): string {
  if (eventType.endsWith("_changed")) {
    return eventType.replace(/_changed$/, "").replaceAll("_", " ");
  }
  return eventType.replaceAll("_", " ");
}
